export default __webpack_public_path__ + "static/media/rank.5875d7f1.png";